import assignWith from "lodash/fp/assignWith";
import isMergeableObject from "./isMergeableObject.mjs";
const mergeProps = assignWith((objValue, srcValue) => {
  if (isMergeableObject(objValue)) {
    return mergeProps(objValue || {}, srcValue || {});
  }
});
export { mergeProps as default };